import React from 'react';
import { Icon } from '../Icon';

export const TermsPage: React.FC<{ onBack: () => void }> = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-theme-bg flex flex-col font-inter transition-colors duration-300">
      <nav className="bg-theme-card border-b border-theme-border px-6 py-4 sticky top-0 z-50 shadow-sm">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <button
            onClick={onBack}
            className="group flex items-center gap-2.5 text-base font-bold text-theme-muted hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
          >
            <Icon
              name="arrow-left"
              className="w-5 h-5 transform group-hover:-translate-x-1.5 transition-transform"
            />
            Voltar ao Hub
          </button>
          <div className="flex items-center gap-3">
            <span className="text-[10px] font-black px-4 py-2 rounded-xl uppercase tracking-widest shadow-sm bg-indigo-50 text-indigo-600 dark:bg-slate-800 dark:text-indigo-400">
              Termos de Uso
            </span>
          </div>
        </div>
      </nav>

      <main className="flex-grow max-w-4xl mx-auto w-full px-6 py-12">
        <div className="bg-theme-card rounded-3xl shadow-sm border border-theme-border p-8 md:p-12">
          <h1 className="text-4xl font-black text-theme-text mb-6">Termos de Uso</h1>
          <p className="text-theme-muted mb-8 leading-relaxed">
            Última atualização: 25/02/2026<br />
            Ao usar a Calculadora PRO, você concorda com estes termos e condições.
          </p>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">1. Aceitação dos Termos</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Ao acessar e usar nosso site, você aceita integralmente estes Termos de Uso.
                  Se não concordar com qualquer parte destes termos, não utilize nossos serviços.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">2. Descrição do Serviço</h2>
              <div className="space-y-3 text-theme-muted">
                <p>A Calculadora PRO oferece ferramentas matemáticas e financeiras gratuitas, incluindo:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Calculadoras financeiras (juros, investimentos, etc.)</li>
                  <li>Ferramentas trabalhistas (salário, férias, etc.)</li>
                  <li>Calculadoras de saúde (IMC, calorias, etc.)</li>
                  <li>Utilidades diversas (conversões, datas, etc.)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">3. Responsabilidade pelo Uso</h2>
              <div className="space-y-3 text-theme-muted">
                <p><strong>Você é responsável por:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Verificar a precisão dos dados inseridos</li>
                  <li>Usar os resultados como referência, não como decisão final</li>
                  <li>Consultar profissionais para decisões importantes</li>
                  <li>Não usar para fins ilegais ou não autorizados</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">4. Limitação de Responsabilidade</h2>
              <div className="space-y-3 text-theme-muted">
                <p><strong>Nossas calculadoras:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>São fornecidas "como estão" sem garantias</li>
                  <li>Podem conter imprecisões ou erros</li>
                  <li>Não substituem aconselhamento profissional</li>
                  <li>Não nos responsabilizamos por decisões baseadas nos resultados</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">5. Propriedade Intelectual</h2>
              <div className="space-y-3 text-theme-muted">
                <p><strong>Todo o conteúdo do site é protegido por:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Direitos autorais (copyright)</li>
                  <li>Leis de propriedade intelectual</li>
                  <li>Marca registrada e design</li>
                </ul>
                <p className="mt-4">É proibido copiar, reproduzir ou distribuir nosso conteúdo sem autorização.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">6. Privacidade e Dados</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Respeitamos sua privacidade conforme descrito em nossa Política de Privacidade.
                  Não armazenamos seus dados pessoais inseridos nas calculadoras.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">7. Uso Aceitável</h2>
              <div className="space-y-3 text-theme-muted">
                <p><strong>Você NÃO pode:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Tentar hackear ou danificar o site</li>
                  <li>Usar automatização excessiva (bots)</li>
                  <li>Plagiar ou copiar nosso conteúdo</li>
                  <li>Violar leis aplicáveis</li>
                  <li>Interferir no uso por outros usuários</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">8. Anúncios e Conteúdo de Terceiros</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Nosso site é financiado por publicidade. Não nos responsabilizamos por:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Conteúdo de anúncios de terceiros</li>
                  <li>Privacidade de sites externos</li>
                  <li>Qualidade de produtos/serviços anunciados</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">9. Disponibilidade do Serviço</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Não garantimos disponibilidade contínua do serviço. Podemos:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Realizar manutenção periódica</li>
                  <li>Atualizar ou remover ferramentas</li>
                  <li>Suspender o serviço temporariamente</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">10. Alterações nos Termos</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Podemos atualizar estes termos a qualquer momento. As alterações entram em vigor
                  imediatamente após publicação. O uso continuado do serviço indica aceitação das mudanças.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">11. Lei Aplicável</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Estes termos são regidos pelas leis do Brasil. Qualquer disputa será resolvida
                  nos tribunais brasileiros, preferencialmente no foro da comarca de São Paulo/SP.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">12. Contato</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Para dúvidas sobre estes termos:</p>
                <div className="bg-theme-bg border border-theme-border rounded-xl p-4 mt-4">
                  <p><strong>Email:</strong> jurusfacil@gmail.com</p>
                  <p><strong>Resposta:</strong> Até 10 dias úteis</p>
                </div>
              </div>
            </section>

            <div className="mt-12 p-6 bg-indigo-50 dark:bg-slate-800/50 rounded-2xl border border-indigo-100 dark:border-slate-700">
              <p className="text-sm text-indigo-900 dark:text-indigo-300 font-medium">
                Ao continuar usando nosso site, você declara ter lido, compreendido e concordado
                com todos os termos e condições descritos acima.
              </p>
            </div>
          </div>
        </div>
      </main>

      <footer className="py-12 border-t border-theme-border text-center mt-auto">
        <p className="text-[10px] font-black text-theme-muted uppercase tracking-[0.3em]">
          Calculadora PRO • Ferramentas Úteis v4.0
        </p>
      </footer>
    </div>
  );
};
